import { Command } from "../../../../Command";
import { ErrorActions } from "../../../flux/Error/ErrorActions";
import { SettingsActions } from "../SettingsActions";
import { appNavigator } from "../../../routes";

// ShowSettingsCommand is executed when app needs to show Settings UI component
// Settings UI can be show multiple times during session, so we need to reset previous state (if any)
export class ShowSettingsCommand implements Command
{
    private readonly settingsActions = new SettingsActions();
    private readonly errorActions = new ErrorActions();
    
    constructor(private errorDispatchToken: string)
    {
    }

    execute = () => {
        this.settingsActions.reject();
        this.errorActions.clearError(this.errorDispatchToken);
        appNavigator.goToSettingsPage();
    };
}


// WEBPACK FOOTER //
// ./src/app/components/Settings/commands/ShowSettingsCommand.ts